export const API_URL = 'https://api.quantumaxis.com.br/widgets/v1/'

export const API_SUBSCRIPTION_KEY = '79e477b0dace44c1bb0b54e06fc8103b'

export const GOOGLE_ANALYTICS_ID = 'UA-213684934-1'

export const HOTJAR_ID = '2718208'

export const HOTJAR_SNIPPET_VERSION = '6'

export const HOME_TITLE = 'Comparador de ativos OUI Investimentos'

export const THEME = 'oui-investimentos'

export const REDUX_PANE = false;
export const REDUX_LOGGER = false;
export const SHARE_URL = 'https://oui.com.br/comparadordeativos/?';
export const APPLICATION_INSIGHTS_CONNECTION_STRING = 'InstrumentationKey=24413b36-11c2-436f-8a26-0505ec7c92a4;IngestionEndpoint=https://brazilsouth-0.in.applicationinsights.azure.com/'

